import { render, staticRenderFns } from "./AsiaPolicyList.vue?vue&type=template&id=3cc055fb"
import script from "./AsiaPolicyList.vue?vue&type=script&lang=js"
export * from "./AsiaPolicyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports